export default __webpack_public_path__ + "static/media/Icons_Password Icon.26ab7663.svg";